<template>

    <div class="ac" :class="{'ac__fixed': isList}">

        <div class="ac__bloc__1">
            <button class="ac__help ac__help__left" @click="openHelp">
                <img src="/img/newsletters-v2/question-mark-circle.svg" :class="$mq === 'lg' ? 'img__40' : 'img__24'">
            </button>
        </div>

        <div>
            <button class="ac__btn ac__btn__red" @click="action(ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES)">
                <div class="sub">
                    <img :src="computedImgUnsubscribes" class="img__28">
                </div>
                <img src="/img/newsletters-v2/delete-white-auto.svg" class="arrow" v-show="isCardsDesktop">
            </button>
        </div>
        <div class="ac__bloc__2">
            <button class="ac__btn ac__btn__orange" @click="action(ENUM.NEWSLETTERS.ACTIONS.DELETE)">
                <div class="sub">
                    <img :src="computedImgDelete" class="ac__btn__orange__image">
                </div>
                <img src="/img/newsletters-v2/delete-white-simple.svg" class="arrow" v-show="isCardsDesktop">
            </button>
        </div>
        <div class="ac__bloc__4" v-show="!isList">
            <button class="ac__btn ac__btn__blue"
                    :class="{ac__btn__locked: laterActionLocked}"
                    :data-highlight="!isList ? ENUM.HIGHLIGHT.LATER_CTA : ''"
                    @click="action(ENUM.NEWSLETTERS.ACTIONS.LATER)">
                <div class="sub">
                    <img :src="computedImgLater" class="ac__btn__blue__image">
                </div>
                <img :src="computedImgLater2" class="arrow" v-show="isCardsDesktop">
            </button>
        </div>
        <div>
            <button class="ac__btn ac__btn__green" @click="action(ENUM.NEWSLETTERS.ACTIONS.KEEP)">
                <div class="sub">
                    <img :src="computedImgKeep" class="img__28">
                </div>
                <img src="/img/newsletters-v2/archive-i-os-white.svg" class="arrow" v-show="isCardsDesktop">
            </button>
        </div>

        <div class="ac__bloc__3">
            <button class="ac__help ac__help__right"
                    :class="{'ac__help__cards-desktop': !isList}"
                    id="help-cta-for-highlight"
                    @click="openHelp">
                <img src="/img/newsletters-v2/question-mark-circle.svg" class="img__24">
            </button>
        </div>

        <bottom-sheet-help ref="bottomSheetHelp"></bottom-sheet-help>

    </div>

</template>

<script>
import Vuex from 'vuex'

import ENUM from '../../assets/ENUM'
import Tag from '../../modules/tag'

import BottomSheetHelp from '../../components/bottomSheet/BottomSheetHelp'

export default {

    name: 'action-bar',

    components: {
        BottomSheetHelp
    },

    props: {
        actualCard: {
            type: Object,
            default: () => {
            }
        },
        isList: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        ...Vuex.mapGetters([
            'isDiscoveryMode'
        ]),

        ENUM() {
            return ENUM
        },

        computedImgUnsubscribes() {
            return this.isCardsDesktop
                ? '/img/newsletters-v2/arrow-white-left.svg'
                : '/img/newsletters-v2/delete-white-auto.svg'
        },

        computedImgDelete() {
            return this.isCardsDesktop
                ? '/img/newsletters-v2/arrow-white-up.svg'
                : '/img/newsletters-v2/delete-white-simple.svg'
        },

        computedImgLater() {
            if (this.laterActionLocked) {
                return this.isCardsDesktop
                    ? '/img/newsletters-v2/arrow-grey-down.svg'
                    : '/img/newsletters-v2/later.svg'
            } else {
                return this.isCardsDesktop
                    ? '/img/newsletters-v2/arrow-white-down.svg'
                    : '/img/newsletters-v2/later.svg'

            }
        },

        computedImgLater2() {
            return this.laterActionLocked
                ? '/img/newsletters-v2/later-grey.svg'
                : '/img/newsletters-v2/later.svg'
        },

        computedImgKeep() {
            return this.isCardsDesktop
                ? '/img/newsletters-v2/arrow-white-right.svg'
                : '/img/newsletters-v2/archive-i-os-white.svg'
        },

        isCardsDesktop() {
            return this.$mq === 'lg'
        },

        laterActionLocked() {
            return this.actualCard && this.actualCard.type === ENUM.NEWSLETTERS.CATEGORIES.LATER
        }
    },

    methods: {

        action(enumAction) {
            this.$emit('action', enumAction)
        },

        openHelp() {
            if (this.isDiscoveryMode) {
                Tag.clickAll(this, 'help')
            }

            if(this.isDesktop) {
                this.$router.push({path: '/help'})
            } else {
                this.$refs.bottomSheetHelp.open()
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.ac {
    width: 100%;

    &:lang(ar-sa) {
        flex-direction: row-reverse;
    }

    &__fixed {
        position: fixed;
        bottom: 81px;
        padding: 0 16px;
        max-width: 100%;
        display: flex;
        flex-direction: row;
        pointer-events: none;

        &:lang(ar-sa) {
            flex-direction: row-reverse;
        }

        @media screen and (min-width: $above-tablet-length) {
            bottom: 22px;
        }
    }

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;


    &__btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 56px;
        border-radius: 72px;
        pointer-events: initial;

        @media screen and (min-width: $above-tablet-length) {
            width: auto;
            height: auto;
            border-radius: 8px;
            display: flex;
            flex-direction: row;
            padding: 10px;
        }

        .arrow {
            width: 24px;
            object-fit: contain;
            margin-left: 8px;
            &:lang(ar-sa) {
                margin-right: 8px;
                margin-left: 0;
            }
        }

        &__red {
            background-color: $raspberry;
            border: solid 4px #fbc5d2;

            width: 64px;
            height: 64px;

            @media screen and (min-width: $above-tablet-length) {
                border: none;
                border-radius: 6px;
                width: auto;
                height: auto;
            }

            .sub {
                display: flex;
                @media screen and (min-width: $above-tablet-length) {
                    padding: 4px;
                    border-radius: 4px;
                    background: linear-gradient(0deg, rgba(240, 72, 113, 0.80) 0%, rgba(240, 72, 113, 0.80) 100%), #FFF;
                }
            }
        }

        &__orange {
            background-color: $sunset;
            border: solid 4px #f9d3b9;
            width: 48px;
            height: 48px;
            @media screen and (min-width: $above-tablet-length) {
                width: auto;
                height: auto;
                border: none;
                border-radius: 6px;
            }

            &__image {
                width: 20px;
                object-fit: contain;
                @media screen and (min-width: $above-tablet-length) {
                    width: 28px;
                }
            }

            .sub {
                display: flex;
                @media screen and (min-width: $above-tablet-length) {
                    padding: 4px;
                    border-radius: 4px;
                    background: linear-gradient(0deg, rgba(236, 116, 35, 0.80) 0%, rgba(236, 116, 35, 0.80) 100%), #FFF;
                }
            }
        }

        &__blue {
            background-color: $aquamarine;
            border: solid 4px #BDE2F9;
            width: 48px;
            height: 48px;
            border-radius: 72px;
            @media screen and (min-width: $above-tablet-length) {
                width: auto;
                height: auto;
                border: none;
                border-radius: 6px;
            }

            &__image {
                width: 20px;
                object-fit: contain;
                @media screen and (min-width: $above-tablet-length) {
                    width: 28px;
                }
            }

            .sub {
                display: flex;
                @media screen and (min-width: $above-tablet-length) {
                    padding: 4px;
                    border-radius: 4px;
                    background: linear-gradient(0deg, rgba(50, 163, 235, 0.80) 0%, rgba(50, 163, 235, 0.80) 100%), #FFF;
                }
            }
        }

        &__green {
            background-color: $lime;
            border: solid 4px #aef1dc;

            width: 64px;
            height: 64px;

            @media screen and (min-width: $above-tablet-length) {
                border: none;
                border-radius: 6px;
                width: auto;
                height: auto;
            }

            .sub {
                display: flex;
                @media screen and (min-width: $above-tablet-length) {
                    padding: 4px;
                    border-radius: 4px;
                    background: linear-gradient(0deg, rgba(0, 209, 145, 0.70) 0%, rgba(0, 209, 145, 0.70) 100%), #FFF;
                }
            }
        }

        &__locked {
            cursor: not-allowed;
            background: $silver;
            border-color: $platinum;

            .sub {
                @media screen and (min-width: $above-tablet-length) {
                    background: $platinum
                }
            }
        }

    }

    &__help {
        min-width: 40px;
        height: 40px;
        border-radius: 72px;
        background-color: $white;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 0 8px 0 rgba(17, 17, 26, 0.1), 0 1px 0 0 rgba(17, 17, 26, 0.05);
        pointer-events: auto;


        &__left {
            visibility: hidden;

            &:lang(ar-sa) {
                visibility: visible;
            }
        }

        &__right {
            visibility: visible;
            margin: 0 4px;

            &:lang(ar-sa) {
                visibility: hidden;
            }
        }


        @media screen and (min-width: $above-tablet-length) {
            position: fixed;
            right: 39px;
            bottom: 18px;
            width: 88px;
            height: 88px;
            box-shadow: none;
            border: solid 2px $platinum;

            &:lang(ar-sa) {
                right: unset;
                left: 39px;
            }

            @media screen and (min-width: $above-tablet-length) {
                width: 64px;
                height: 64px;
            }
        }

        &__cards-desktop {
            @media screen and (min-width: $above-tablet-length) {
                bottom: 40px;
            }
        }
    }

    &__help-ghost {
        min-width: 40px;

        @media screen and (min-width: $above-tablet-length) {
            width: 0;
        }
    }

    &__bloc {

        &__1 {
            flex: 1;
        }

        &__2 {
            padding: 0 8px 0;
        }

        &__3 {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &__4 {
            padding-right: 8px;
        }
    }
}

</style>
